var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckboxCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 160 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M129 57l-57 58c-2,1 -3,1 -4,1 -1,0 -3,0 -4,-1l-33 -33c-1,-2 -1,-5 0,-7 2,-2 6,-2 8,0l29 29 54 -54c2,-2 5,-2 7,0 2,2 2,5 0,7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxCheck);
export default __webpack_public_path__ + "static/media/checkbox-check.b7581968.svg";
export { ForwardRef as ReactComponent };